<mat-card appearance="outlined" class="cardLocation">
	<h2 style="padding-left:18px;padding-top:5px;">Location</h2>
	<mat-card-content>
		<div class="row">
			<div>
				<mat-label>Region(s)</mat-label><br>
							
							

				<!--  *ngIf="!isLoadingResults" {{selectedRegionIds}}   [selectRegionIds]="[school?.REGIONS!.ID]" -->
				<region-dropdown-two-way 
					id="myRegion" 
					(selectedRegionsChange)="regionsSelected($event)"
					[reset]="resetFieldRegions" [isMultiple]="true"  #child2
					[(selectedRegions)]="chosenRegions">
				</region-dropdown-two-way>

				<!-- <region-dropdown id="myRegion" 
					class="restrictWidth" 
					[isMultiple]="true" 
					[reset]="resetFieldRegions"
					(eventEmitterRegioncode)="regionsSelected($event)" 
					[allowAllRegions]="true" #child2>
				</region-dropdown> -->
			</div>
			<div>
				<mat-label>County(s)</mat-label><br>
				<!-- [selectCountyIds]="selectedCountyIds" [selectCountyIds]="[school?.COUNTy!.ID]"-->
				<county-dropdown-two-way id="myCounty1" [isMultiple]="true" [reset]="resetFieldCounties"
					[regions]="chosenRegions" (selectedCountiesChange)="countiesSelected($event)" [(selectedCounties)]="chosenCounties"
					#child3></county-dropdown-two-way>
			</div>
		</div>
		<div *ngIf="showDistrictDropdown" class="row">
			<div>
				<mat-label>District(s)</mat-label><br>
				<!-- *ngIf="!isLoadingResults" [selectSchoolDistrictIds]="[selectedSchoolDistrictId]"  [selectSchoolDistrictIds]="[selectedSchoolDistrictId]"  -->
				<district-dropdown-two-way (selectedSchoolDistrictsChange)="districtsSelected($event)"
					[regions]="chosenRegions" [counties]="chosenCounties" [autoRefreshOnRegionChange]="true"
					[reset]="resetFieldDistricts" #child [isMultiple]="true">
				</district-dropdown-two-way>
			</div>
		</div>
	</mat-card-content>
</mat-card>